<template>
  <div class="bl_main_wrapper error-404-cont">
    <div class="bl_main_container">
      <div class="bl_main">
        <div class="bl_hp_main">
          <div class="bl_404_msg">
            <img src="http://www.bloomingdales.com/img/misc/404error.gif" alt="The page you requested no longer exists." />
            <p class="bl_bold_msg">Oops! Looks like this page is no longer in style.</p>
            <p>
              Try visiting our <a href="https://www.bloomingdales.com">homepage</a>,
              <a href="https://www.customerservice-bloomingdales.com/app/contact/">contact us</a> if for help or call Customer Service at
              1-800-777-0000.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bl_404_msg {
  padding: rem-calc(100px) 0;
  text-align: center;
  .bl_bold_msg {
    font-weight: 800;
  }

  p {
    font-size: 1em;
    margin: 1.5em 0;
    text-rendering: optimizeLegibility;
  }
}
</style>
